import api from './api';
import { AUTH_TOKEN } from 'constants/AuthConstant';

export const AUTH_USER = 'AUTH_USER';

const AuthService = {
  async login(payload) {
    const response = await api.post('/auth/login', payload);
    return response.data;
  },

  async me() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async register(payload) {
    const response = await api.post('/users', {
      name: payload.name || 'Usuário',
      email: payload.email,
      password: payload.password,
      role: 'OPERATOR',
      status: 'ACTIVE',
    });
    return response.data;
  },

  async loginInOAuth() {
    throw new Error('Login social ainda não configurado.');
  },

  setSession(accessToken, user) {
    localStorage.setItem(AUTH_TOKEN, accessToken);
    localStorage.setItem('token', accessToken);
    localStorage.setItem(AUTH_USER, JSON.stringify(user));
  },

  clearSession() {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem('token');
    localStorage.removeItem(AUTH_USER);
  },

  getUser() {
    try {
      const raw = localStorage.getItem(AUTH_USER);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },
};

export default AuthService;